import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { SitesService } from 'src/app/services/sites.service';
import { BeachSite } from 'src/app/models/BeachSite';
import { BehaviorSubject, from } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import NavMenuService from 'src/app/navigation-menu/nav-menu-service';
import { NSWLogoAltText } from 'src/app/models/app-constants';
import { environment } from 'src/environments/environment';
import { AppMonitoringService } from 'src/app/services/logging.service';

@Component({
	selector: 'app-master-brand',
	templateUrl: './master-brand.component.html',
	styleUrls: ['./master-brand.component.scss']
})
export class MasterBrandComponent implements OnInit {
    private sites$: BehaviorSubject<BeachSite[]> = new BehaviorSubject<BeachSite[]>([]);
    
    public dropdownValues: dropdownValue[] = [];
    public menuShown = false;
    public searchOpen = false;
    public searchFControl = new FormControl('');
    
    public NSWLogoAltText : string = NSWLogoAltText;

    @ViewChild('searchInput') searchEle: ElementRef;
	@Output() mobileMenuButtonClicked: EventEmitter<any> = new EventEmitter();

	constructor(private sitesService: SitesService,
		private router: Router,
		private httpClient: HttpClient,
		private navMenuService: NavMenuService,
        private activatedRoute : ActivatedRoute, private appMonitoring: AppMonitoringService) 
    {
        
    }
   

    onMobileMenuClicked = () => {
		this.menuShown = !this.menuShown;
		this.navMenuService.setActivated(this.menuShown);
	}

	 ngOnInit(): void {
        this.sitesService.getSites().subscribe({
            next: (data) => {
                this.sites$.next(data);
            },
            error: (error) => 
            {

            },
            complete: () => 
            {

            },
        });    
        

        this.searchFControl.valueChanges.subscribe((value) => {
            if (value && value.length >= 3) 
            {
                this.onSearchChange(value);
            } else {
                this.dropdownValues = [];
            }
        });
    }
    
    navigateToPage(selVal: dropdownValue): void {
        if (this.isFullUrl(selVal.url)) {
            window.open(selVal.url, '_blank')
        }
        else{
            // track the site that was clicked from the GlobalSearch
            this.appMonitoring.logEvent('SiteDetailsLoadFromGlobalSearch',{'site_identifier':selVal.site_identifier})

            this.router.navigateByUrl(selVal.url)
        }
    }

    getDisplayName(val: dropdownValue): string {
        return val.display;
    }

    isFullUrl(url: string) {
        try {
            const parsedUrl = new URL(url);
            return parsedUrl.protocol !== '';
        } catch (e) {
            return false;
        }
    }

    googleSearch(query: string) {
        const url = `${environment.customSearchApi}?key=${environment.customSearchApiKey}&cx=${environment.customSearchEngineId}&q=${query}&num=3&safe=active`;

        this.httpClient.get(url).subscribe((res: any) => {
            if (res && res.searchInformation.totalResults > 0) {
                this.dropdownValues.splice(
                    0,
                    this.dropdownValues.length,
                    ...this.dropdownValues.filter((z) => z.source != 'google')
                );
                this.dropdownValues = this.dropdownValues.concat(
                    res['items']
                        .map(
                            (x: any) =>
                                new dropdownValue(
                                    x['title'],
                                    x['link'],
                                    'google'
                                )
                        )
                        .slice(0, 3)
                );
            }
        });
    }

    highlight(name: string, query: any): string {
        const regex = new RegExp(query, 'gi');
        let replaceStr = name.slice(
            regex.exec(name)?.index,
            query.length
        );

        return name.replace(regex, `<strong>${replaceStr}</strong>`);
    }

    onSearchClicked(): void {
        this.searchOpen = !this.searchOpen;
        setTimeout(() => {
            this.searchEle && this.searchOpen
                ? this.searchEle.nativeElement.focus()
                : null;
        });
    }

    onEnterPressed(evt: Event){
        evt.preventDefault();
    }

    onSearchChange(searchValue: string): void {
        //uncomment this when we a google account setup
        this.googleSearch(searchValue);

        let startsWithList: Array<BeachSite> = this.sites$
            .getValue()
            .filter((z) => {
                if (z.SiteName) {
                    if (
                        z.SiteName.toLocaleLowerCase().startsWith(
                            searchValue.toLocaleLowerCase()
                        )
                    ) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            });

        let containsList: Array<BeachSite> = this.sites$
            .getValue()
            .filter((z) => {
                if (z.SiteName) {
                    if (
                        z.SiteName.toLocaleLowerCase().includes(
                            searchValue.toLocaleLowerCase()
                        )
                    ) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            });

        if (startsWithList.length > 0) {
            this.dropdownValues.splice(
                0,
                this.dropdownValues.length,
                ...this.dropdownValues.filter((z) => z.source != 'bw')
            );
            this.dropdownValues = this.dropdownValues.concat(
                startsWithList
                    .map(
                        (site) =>
                            new dropdownValue(
                                site.SiteName,
                                `/siteDetails/${site.Identifier}`,
                                'bw',site.Identifier
                            )
                    )
                    .slice(0, 3)
            );
        } else {
            this.dropdownValues = [];
        }
    }
}

class dropdownValue {
	display: string;
	url: string;
	source: string;
    site_identifier?: string;

	constructor(_display: string, _url: string, _source: string, _site_identifier?: string) {
		this.display = _display;
		this.url = _url;
		this.source = _source;
        this.site_identifier = _site_identifier;
	}
}
